export function getProductByCategory(state) {
  return (category) => {
    if (state.products) {
      return state.products.find((value) => value.category === category);
    }
    return null;
  };
}
